import { ClientsStatusReport } from 'components/Report';
import { endpoints } from 'api';

function NewClientsPage() {
    return (
        <ClientsStatusReport APIEndpoint={endpoints.NEW_CLIENTS_REPORT} ReportName='New Clients' />
    );
}
export default NewClientsPage;
